import styled from 'styled-components'

export const StyledContainer = styled.div`
  width: 100%;
`

export const StyledTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const StyledTitle = styled.h3`
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;

  color: #120224;
`

export const StyledRequiredMsg = styled.p`
  font-weight: 500;
  font-size: 10px;
  line-height: 14px;
  letter-spacing: 1.5px;
  text-transform: uppercase;

  color: #b3b3b3;
`

export const StyledDescription = styled.p`
  margin: 12px 0;

  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #120224;
`

export const StyledCustomerCardsContainer = styled.div`
  width: 50%;

  display: flex;
  column-gap: 24px;
  justify-content: center;
  align-items: center;
`

export const LendingIssuesContainer = styled.div`
  margin-bottom: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const StyledLendingIssuesHeader = styled.div`
  margin: 24px 0;
  width: 100%;
  background-color: #e73f3f;
  border-radius: 4px;
  padding: 16px;
`

export const StyledIssueTitle = styled.p`
  font-size: 16px;
  font-weight: 700;
  color: #fefefe;
`

export const StyledDetailsContainer = styled.div`
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const StyledHeaderWarning = styled.p`
  font-size: 16px;
  font-weight: 700;
  color: #000000;
`

export const StyledWarningsContainer = styled.div`
  align-self: flex-start;

  padding: 0 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-top: 24px;
  row-gap: 16px;
`

export const StyledWarningContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`
export const StyledWarningWithIndex = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 8px;
`
export const StyledWarningDescription = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;

  margin-top: 8px;
`

export const StyledIndex = styled.div`
  height: 24px;
  width: 24px;

  background-color: #ff8a80;
  border-radius: 4px;

  display: flex;
  justify-content: center;
  align-items: center;

  color: #fff;
`

export const StyledBoldText = styled.p`
  font-size: 16px;
  color: #d32f2f;
  font-weight: 700;
`

export const StyledText = styled.p`
  font-size: 1rem;
  color: #d32f2f;
  font-weight: 400;
`

export const Styled2x2Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
`
